<template>
    <section>
        <vue-topprogress color="#f7b400" ref="topProgress"></vue-topprogress>
        <McTable :punishments="punishments" :with-type="false"/>
        <Loading v-show="showLoader" class="loading"></Loading>
        <div class="pagination">
            <Pagination :current-page="this.$route.params.page" :max-page="maxPage"/>
        </div>
    </section>
</template>

<script>
    import Pagination from '../../components/Pagination'
    import McTable from '../../components/tables/McTable'
    import Progress from 'vue-top-progress'
    import Loading from '../../components/Loading'

    export default {
        components: {
            Pagination,
            McTable,
            Progress,
            Loading
        },
        data() {
            return {
                maxPage: 1,
                punishments: [],
                showLoader: true
            }
        },
        created() {
            if (this.$route.name !== 'names' || (this.$route.name === 'names' && this.$api.getUser().hasPermission(['bansite.view.nameban', 'bansite.view.*']))) {
                this.updatePunishments();
                this.updatePageMax();
            } else {
                setTimeout(() => {
                    if (this.$refs.topProgress !== undefined) {
                        this.$refs.topProgress.fail()
                    }
                }, 2000);
            }
        },
        mounted() {
            if (this.$refs.topProgress !== undefined) {
                this.$refs.topProgress.start();
            }
        },
        computed: {
            type() {
                return this.$utils.getPageType(this.$route.name).type;
            },
            category() {
                return this.$utils.getPageType(this.$route.name).category;
            },
        },
        methods: {
            updatePageMax() {
                this.$api.getCounts(this.category, this.type).then(counts => {
                    this.maxPage = Math.ceil(counts[this.type] / 50);
                });
            },
            updatePunishments() {
                this.$api.getPunishments(this.category, this.type, this.$route.params.page).then(res => {
                    this.punishments = res;
                    this.showLoader = false;
                    if (this.$refs.topProgress !== undefined) {
                        this.$refs.topProgress.done()
                    }
                }).catch(err => {
                    console.log(err);
                    if (this.$refs.topProgress !== undefined) {
                        this.$refs.topProgress.fail()
                    }
                });
            },
        },
    }
</script>

<style lang="scss" scoped>
    section {
        padding: 0 20px;

        .loading {
            margin-top: 50px;
        }

        .table {
            min-height: 450px;
        }

        .pagination {
            display: flex;
            margin-top: 2rem;
            justify-content: center;
        }

        table {
            width: 100%;
            font-size: 16.5px;
            margin-bottom: 0;
            text-align: center;
            border-collapse: collapse;

            thead {
                background: #262a2d;

                th {
                    vertical-align: middle;
                    overflow-wrap: break-word;
                    padding: .75rem;
                    font-weight: bold;

                    &.small {
                        width: 15%;
                    }
                }
            }

            tbody {
                tr {
                    background-color: rgba(0, 0, 0, .05);

                    &:nth-of-type(odd) {
                        background-color: hsla(0, 0%, 100%, .05);
                    }

                    td {
                        vertical-align: middle;
                        overflow-wrap: break-word;
                        padding: .75rem;

                        a {
                            color: #fff;
                            text-decoration: none;
                        }
                    }

                    .user {
                        img {
                            border-radius: 2px;
                            display: block;
                            margin: 0 auto;
                            vertical-align: middle;
                            padding-bottom: 5px;
                        }
                    }

                    .expired {
                        padding-top: 5px;
                        font-style: italic;
                        font-size: 15px;
                        color: #878e94;
                        max-width: 100%;
                        overflow: hidden;
                        white-space: nowrap;
                        text-overflow: ellipsis;
                    }
                }
            }
        }
    }
</style>
